module.exports = __webpack_public_path__ + "img/virtual-gallery-2020.319a08b1.jpg";